<template>
  <div
    style="
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    background: #0d0221;
    "
  >
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="467" height="224" viewBox="0 0 267 124">
      <defs>
        <clipPath id="clip-path">
          <rect id="Rectangle_1" data-name="Rectangle 1" width="254.096" height="107.076" fill="#fff" />
        </clipPath>
        <clipPath id="clip-MYFO_REFONTE_V3_5">
          <rect width="267" height="124" />
        </clipPath>
      </defs>
      <g id="MYFO_REFONTE_V3_5" data-name="MYFO REFONTE V3 – 5" clip-path="url(#clip-MYFO_REFONTE_V3_5)">
        <g id="Groupe_433" data-name="Groupe 433" transform="translate(6 8.001)">
          <g id="Groupe_1" data-name="Groupe 1" transform="translate(0 0)" clip-path="url(#clip-path)">
            <path
              id="Tracé_1"
              data-name="Tracé 1"
              d="M81.033,102.773H65.211c0-.54,0-1.036,0-1.533-.011-9.767,0-19.534-.055-29.3a8.751,8.751,0,0,0-2.024-6.026c-1.907-2.129-5.525-2.685-8.9-1.374-3.952,1.535-5.2,4.86-5.616,8.67a40.577,40.577,0,0,0-.16,4.323q-.021,11.848-.007,23.7v1.552h-15.9c0-.462,0-.949,0-1.435-.012-9.385.029-18.77-.082-28.154a18.886,18.886,0,0,0-1.016-5.46,5.17,5.17,0,0,0-4.24-3.632c-5.694-.961-9.992,1.523-10.971,7.727a40.752,40.752,0,0,0-.434,6.085c-.048,7.771-.019,15.543-.019,23.314v1.553H0V51.228H15.138v6.636c3.956-5.656,9.359-8.157,16.073-7.978,6.679.178,12.044,2.667,15.213,8.97.875-1.173,1.65-2.328,2.541-3.386a14.949,14.949,0,0,1,8.852-5.139,24.8,24.8,0,0,1,10.626.144C75.167,52.1,78.716,56.763,80.164,63.2a36.3,36.3,0,0,1,.9,7.56c.1,10.276.042,20.554.038,30.831,0,.372-.043.745-.07,1.185"
              transform="translate(0 -21.286)"
              fill="#fff"
            />
            <path
              id="Tracé_2"
              data-name="Tracé 2"
              d="M157.857,127.349c.71-4.345,1.4-8.566,2.112-12.923.532.162,1,.282,1.459.449a17.888,17.888,0,0,0,9.154.778,7.139,7.139,0,0,0,5.58-4.172c1.033-2.18,1.939-4.425,2.792-6.682a2.519,2.519,0,0,0-.231-1.666q-7.978-18.44-16-36.859c-2.024-4.657-4.041-9.317-6.139-14.155h3.664c4.123,0,8.247.039,12.369-.029a1.53,1.53,0,0,1,1.71,1.206q6.013,15.6,12.1,31.171c.206.529.43,1.052.793,1.94.76-2.242,1.4-4.1,2.019-5.967,3-9.006,6.011-18.007,8.957-27.03a1.612,1.612,0,0,1,1.874-1.317c4.928.056,9.858.025,14.879.025a5.9,5.9,0,0,1-.178.756q-12.388,31.811-24.817,63.607a33.919,33.919,0,0,1-3.32,6.277c-2.6,3.921-6.6,5.589-11.1,6.189a39.38,39.38,0,0,1-16.894-1.284c-.237-.072-.462-.184-.784-.314"
              transform="translate(-66.892 -22.253)"
              fill="#fff"
            />
            <path
              id="Tracé_3"
              data-name="Tracé 3"
              d="M400.833,77.09c0,13.741-9.169,24.4-22.817,26.566-7.394,1.171-14.521.422-21.111-3.271-8.647-4.845-13.008-12.4-13.4-22.236-.313-7.883,2.035-14.829,7.781-20.4a28.206,28.206,0,0,1,17.865-7.742A30.983,30.983,0,0,1,388.8,54.437c7.872,4.968,12.033,12.877,12.032,22.653m-15.9-.037a14.081,14.081,0,0,0-2.574-8.489c-3.123-4.161-9.2-5.754-14.768-3.987-9.909,3.142-9.976,16.7-4.782,21.919,3.471,3.49,9.559,4.681,14.575,2.715,4.771-1.871,7.526-6.308,7.549-12.158"
              transform="translate(-146.737 -21.303)"
              fill="#fff"
            />
            <path
              id="Tracé_4"
              data-name="Tracé 4"
              d="M305.338,1.087c-.247,4.413-.494,8.807-.728,12.989-2.253-.2-4.425-.576-6.593-.552-3.6.039-5.558,1.6-5.976,5.155-.427,3.643-.335,7.347-.475,11.161h11.877V42.521H291.716V81.49H275.822V42.614H265.385v-12.7H275.8c0-.585-.008-1.034,0-1.484.083-4.327-.058-8.674.306-12.978.56-6.613,3.446-11.816,10.161-14.014a29.012,29.012,0,0,1,6.6-1.28,38.35,38.35,0,0,1,11.542.652c.287.064.566.166.929.274"
              transform="translate(-113.375 0)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  props: [],

  data() {
    return {
      form: [],
    };
  },
  methods: {},
};
</script>
<style lang="scss">
#homepage_container {
  position: relative;
  z-index: 1;
  padding: 50px;
  @media screen and (max-width: 768px) {
    padding: 20px;
  }
}

#Ellipse_82 {
  opacity: 0;
  animation: fadein forwards 2s;
  animation-delay: 0.5s;
}

#Ellipse_83 {
  opacity: 0;
  animation: fadein forwards 2s;
  animation-delay: 1s;
}

#Ellipse_84 {
  opacity: 0;
  animation: fadein forwards 2s;
  animation-delay: 1.5s;
}

@keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fond3Svg {
  width: 72%;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 0;
}

.pathLine {
  animation: dashLine 3s ease-in;
  animation-fill-mode: forwards;
}

@keyframes dashLine {
  to {
    stroke-dashoffset: 0;
  }
}

#Rectangle_229 {
  width: 0;
  animation: fadezzd ease-in forwards 2.5s;
  @keyframes fadezzd {
    from {
      width: 0;
    }
    to {
      width: 100%;
    }
  }
}

.form_email {
  width: 91%;
}

@media (max-width: 768px) {
  .form_email {
    width: 100%;
  }
}

@media (max-width: 992px) {
  .form_email {
    width: 85%;
  }
}
</style>
